import React from 'react';
import { material } from '../../../library/material';

function WelcomePage(props) {
    return (
        <div
            className="d-flex justify-content-center align-items-center"
            style={{
                minHeight: "100vh",
                width: "100%",
                backgroundColor: "#f5f5f5",
                padding: "20px",
            }}
        >
            <material.Card
                style={{
                    maxWidth: "600px",
                    width: "100%",
                    borderRadius: "16px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                }}
            >
                <material.CardContent style={{ padding: "40px" }}>
                    <material.Typography
                        variant="h5"
                        align="center"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                    >
                        Thank You for Your Submission!
                    </material.Typography>
                    <material.Typography variant="body1" align="center" paragraph>
                        Thank you for submitting your details to the Aesthetic Consults
                        Patient Management Platform.
                    </material.Typography>
                    <material.Typography variant="body1" align="center" paragraph>
                        We have successfully received your information.
                    </material.Typography>
                    <material.Typography variant="body1" align="center" paragraph>
                        Our team will review your submission and contact you shortly to
                        guide you through the next steps in the process.
                    </material.Typography>
                    <material.Typography variant="body1" align="center" paragraph>
                        We appreciate your trust and look forward to assisting you!
                    </material.Typography>
                </material.CardContent>
            </material.Card>
        </div>
    );
}

export default WelcomePage;